import { Camera } from '@capacitor/camera';
import { CameraResultType } from '@capacitor/camera';

async function isCameraAvailable() {
  const result = await Camera.isAvailable();
  return result && result.value;
}

async function hasCameraPermission() {
  const result = await Camera.checkPermissions();
  return result && result.camera === 'granted';
}

async function requestCameraPermission() {
  const result = await Camera.requestPermissions();
  return result && result.camera === 'granted';
}

async function capturePhoto() {
  try {
    const image = await Camera.getPhoto({
      quality: 90,
      allowEditing: false,
      resultType: CameraResultType.Base64
    });
    return image && image.base64String;
  } catch (error) {
    console.error('Errore durante la cattura della foto:', error);
    return null;
  }
}

export { isCameraAvailable, hasCameraPermission, requestCameraPermission, capturePhoto };
